import { cva } from '@/styled-system/css';

export const propertyCardPhotoRecipe = cva({
  base: {
    'borderStartStartRadius': 'obj.default',
    'borderStartEndRadius': '0',
    'height': '100%',
    'overflow': 'hidden',
    'position': 'relative',
    'zIndex': 0,
    'backgroundColor': 'PropertyCard.PhotoFallback.bg',

    '&:is(img), & img': {
      objectFit: 'cover',
      overflow: 'clip',
      inlineSize: '100%',
      // Ensures portait images don't increase height of container in
      // horizontal cards (CDS-1396)
      blockSize: '0',
      minBlockSize: '100%',
    },
  },
  variants: {
    appearance: {
      large: {
        borderStartEndRadius: 'obj.default',
        borderEndStartRadius: '0',
      },
      small: {
        borderStartEndRadius: 'obj.default',
        borderEndStartRadius: '0',
      },
      horizontal: {
        borderStartEndRadius: '0',
        borderEndStartRadius: 'obj.default',
      },
    },
    photoOrientation: {
      landscape: {},
      portrait: {
        '_after': {
          backgroundImage: 'var(--c11n-background-image)',
          backgroundColor: 'PropertyCard.PhotoFallback.bg',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          content: '""',
          display: 'block',
          filter: 'blur(8px)',
          position: 'absolute',
          inset: '0',
          zIndex: '-1',
        },

        '&:is(img), & img': {
          objectFit: 'contain',
        },
      },
    },
  },
});
